export const messages = {
  en: {
    mappingDomain: {
      queryCondition: 'Query Conditions',
      selectDomain: 'Please select domain',
      selectSeq: 'Please select sequence',
      query: 'Query',
      configItems: 'Configuration Items',
      add: 'Add',
      name: 'Name',
      configItem: 'Configuration Item',
      seq: 'Sequence',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      save: 'Save',
      remark: 'Description',
      namePlaceholder: 'Required, please enter name',
      configItemPlaceholder: 'Required, please enter configuration item',
      seqPlaceholder: 'Required, please enter sequence',
      remarkPlaceholder: 'Required, please enter description',
      nameRequired: 'Name is required',
      configItemRequired: 'Configuration item is required',
      configItemMaxLength: 'Configuration item cannot exceed 50 characters',
      seqRequired: 'Sequence is required',
      seqMaxLength: 'Sequence cannot exceed 12 characters',
      remarkRequired: 'Description is required',
      remarkMaxLength: 'Description cannot exceed 256 characters',
      idRequired: 'ID is required',
      confirmOperation: 'Please confirm your operation!',
      confirmDeleteConfig: 'Confirm to delete configuration item?',
      cancelDelete: 'Cancel',
      confirmDelete: 'Confirm Delete!',
      addSuccess: 'Added successfully',
      editSuccess: 'Modified successfully',
      deleteSuccess: 'Deleted successfully'
    }
  },
  zh: {
    mappingDomain: {
      queryCondition: '查询条件',
      selectDomain: '请选择域',
      selectSeq: '请选择排序',
      query: '查询',
      configItems: '配置项',
      add: '添加',
      name: '名称',
      configItem: '配置项',
      seq: '排序',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      cancel: '取消',
      save: '保存',
      remark: '描述',
      namePlaceholder: '必填，请填写名称',
      configItemPlaceholder: '必填，请填写配置项',
      seqPlaceholder: '必填，请填写排序',
      remarkPlaceholder: '必填，请填写描述',
      nameRequired: '名称不能为空',
      configItemRequired: '配置项不能为空',
      configItemMaxLength: '配置项不能超过50个字符',
      seqRequired: '排序不能为空',
      seqMaxLength: '排序不能超过12个字符',
      remarkRequired: '描述不能为空',
      remarkMaxLength: '描述不能超过256个字符',
      idRequired: '编号不能为空',
      confirmOperation: '请确认您的操作!',
      confirmDeleteConfig: '确定删除配置项?',
      cancelDelete: '点错了',
      confirmDelete: '确认删除!',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功'
    }
  }
}